import Footer from "../../components/Footer/Footer";
import { localLegalInfo } from "../../components/utils/local.policy";
import { getStore } from "../../services/backend/serverSideProps";
import styles from "./contact.module.css";

export async function getServerSideProps(context) {
  return getStore(context);
}

const Contact = (props) => {
  const { storeData } = props;
  const storeName = storeData.storeName;
  let contacts =
    storeData?.legalInfo && storeData?.legalInfo.contacts
      ? storeData?.legalInfo.contacts
      : localLegalInfo.contacts;
  contacts = contacts.replace("{{store email}}", storeData.email ? storeData.email : "NA");
  contacts = contacts.replace(
    "{{store phone}}",
    storeData.supportPhone ? storeData.supportPhone : "NA",
  );
  contacts = contacts.replaceAll("{{store instagram}}", storeData.instagramHandle);
  return (
    <div className={styles.container}>
      <main>
        <h2 className={styles.headline}>Contact Us</h2>
        {contacts.trim() != "" ? (
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: contacts }}></div>
        ) : null}
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
